import { assertSqliteFeatureContract } from './define-feature'

const FEATURE_MODULES = import.meta.glob('./**/*-feature.js', { eager: true })

const resolveFeatureEntries = () =>
    Object.entries(FEATURE_MODULES)
        .map(([path, module]) => ({ path, feature: module?.default || null }))
        .filter((entry) => Boolean(entry.feature))
        .sort((a, b) => {
            // Stable deterministic order without manual registry maintenance.
            const aOrder = Number.isFinite(Number(a.feature?.order)) ? Number(a.feature.order) : Number.MAX_SAFE_INTEGER
            const bOrder = Number.isFinite(Number(b.feature?.order)) ? Number(b.feature.order) : Number.MAX_SAFE_INTEGER
            if (aOrder !== bOrder) return aOrder - bOrder
            const aKey = String(a.feature?.key || '')
            const bKey = String(b.feature?.key || '')
            return aKey.localeCompare(bKey)
        })

const validateRegistry = (entries) => {
    const seen = new Set()
    for (const { path, feature } of entries) {
        assertSqliteFeatureContract(feature, `feature module "${path}"`)
        if (seen.has(feature.key)) {
            throw new Error(`[SQLite][Feature] Duplicate feature key "${feature.key}"`)
        }
        seen.add(feature.key)
    }
}

const FEATURE_ENTRIES = resolveFeatureEntries()
validateRegistry(FEATURE_ENTRIES)

export const SQLITE_FEATURES = Object.freeze(FEATURE_ENTRIES.map((entry) => entry.feature))
